<template>
  <div class="flex flex-col">
    <div class="p-2">
      <div class="border-b-2">
        {{ sectionName }}
      </div>
    </div>
    <div class="grid grid-cols-2">
      <div class="grid grid-cols-4 p-2 rounded-l-md bg-gray-200">
        <div class="grid col-span-1 font-bold uppercase text-sm text-gray-400">
          Previous
        </div>
        <div class="grid col-span-3">
          <slot name="prev"></slot>
        </div>
      </div>
      <div class="grid grid-cols-4 p-2 rounded-r-md bg-sky-600">
        <div class="grid col-span-1 font-bold uppercase text-sm text-green-600">
          Current
        </div>
        <div class="grid col-span-3">
          <slot name="curr"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sectionName: String
  }
}
</script>
